import { getZones, getZonesParams } from '@/shared/actions/erp';
import { Flota, Zone } from '@/shared/interfaces';
import { create } from 'zustand';


interface AsignarZonaFlotaState {
  zones: Zone[];
  isLoadingZone: boolean;
  getZone: (params: getZonesParams) => void;

  listaZonas: Zone[];
  setListaZonas: (listaZonas: Zone[]) => void;

  flotaSelect: Flota | null;
  setFlotaSelect: (flotaSelect: Flota | null) => void;

}

export const useAsignarZonaFlota = create<AsignarZonaFlotaState>(set => ({


  flotaSelect: null,
  setFlotaSelect(flotaSelect) {
    set({ flotaSelect: flotaSelect })
  },

  zones: [],
  isLoadingZone: false,
  getZone: async (params) => {
    set({ isLoadingZone: true });
    const { data } = await getZones(params);
    set({ zones: data.data });
    set({ isLoadingZone: false });
  },

  listaZonas: [],
  setListaZonas(listaZonas) {
    set({ listaZonas: listaZonas })
  },

}));
